module.exports = __webpack_public_path__ + "static/media/gradeView.98036914.webp";